<template>
    <confirmation-dialog
        v-model="error" 
        :title="$t('ERROR')"
        max-width="50%"
        :cancel="false"
        :confirm="$t('OK')"
        @confirm="clearError"
        persistent>
        <template slot="titleIcon">
            <v-icon color="error" size="1.5em">error</v-icon>
        </template>
        {{error}}
    </confirmation-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import ConfirmationDialog from './ConfirmationDialog.vue';
import { Prop } from "vue-property-decorator";
import { useErrorStore } from "@/stores/errorStore";

@Component({
    components: {
        ConfirmationDialog
    }
})
export default class ErrorDialog extends Vue {
    @Prop(String) error: String;

    clearError() {
        useErrorStore().resetError();
        this.$emit("confirm", undefined);
        this.$emit("input", false);
    }
}
</script>
<style scoped>
</style>